"use strict";
const EventEmitter = require("events");
const DateTimePicker = require("@gluenetworks/date_time_picker").DateTimePicker;
const ButtonControl = require("@gluenetworks/button_control");
const moment = require("moment");

class DateTimePickerInput extends EventEmitter {
    constructor(fieldName) {
        super();
        this._rootElem = document.createElement("date-time-picker-popup-gl");

        this._fieldName = fieldName;
        this._inputName = "";

        this._rendered = false;

        this._inputValue = new Date().setSeconds(0);

        let config = {
            showDate: true,
            showTime: true,
        };
        this._dateTimePickerComp = new DateTimePicker(config);

        this._onBodyClick = this._onBodyClick.bind(this);

        this.render();
    }

    set rendered(rendered) {
        this.setRendered(rendered);
    }
    setRendered(rendered) {
        this._rendered = rendered;
    }
    get rendered() {
        return this.isRendered();
    }
    isRendered() {
        return this._rendered;
    }

    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }

    get calendarPopup() {
        return this._popupElem;
    }

    setInputName(inputName) {
        this._inputName = inputName;
    }
    get inputName() {
        return this.getInputName();
    }
    getInputName() {
        return this._inputName;
    }

    setValue(value) {
        this._inputValue = value;
        this.updateLabel();
    }

    get value() {
        return this.getValue();
    }
    getValue() {
        return this._inputValue;
    }

    updateLabel() {
        const date = new Date(this.getValue());
        if (this._dateLabelElem) {
            this._dateLabelElem.innerText = `${date.toLocaleDateString()} ${date.toLocaleTimeString(
                [],
                {hour: "2-digit", minute: "2-digit"}
            )}`;
        }
    }

    render() {
        if (this.isRendered()) {
            return Promise.resolve();
        }

        this._dateLabelElem = document.createElement("button");
        this._dateLabelElem.classList.add("date-label");
        this._popupElem = document.createElement("popup-gl");
        this._okCancelElem = document.createElement("ok-cancel-gl");
        this._dateOkButtonComp = new ButtonControl({label: "\u2714"});
        this._dateCancelButtonComp = new ButtonControl({label: "\u2718"});

        return Promise.resolve()
            .then(() => {
                this._popupElem.appendChild(this._dateTimePickerComp.renderer.rootElement);
                this._hideElm(this._popupElem);
                this._okCancelElem.appendChild(this._dateOkButtonComp.renderer.rootElement);
                this._okCancelElem.appendChild(this._dateCancelButtonComp.renderer.rootElement);
                this._rootElem.appendChild(this._dateLabelElem);
                this._rootElem.appendChild(this._popupElem);
                this._popupElem.appendChild(this._okCancelElem);
                return this._dateTimePickerComp.renderer.render();
            })
            .then(() => {
                this._registerListeners();
                this.updateLabel();
                this.setRendered(true);
            });
    }

    shutdown() {
        if (!this.isRendered()) {
            return Promise.resolve();
        }

        return Promise.resolve()
            .then(() => {
                this._unregisterListeners();
                this._rendered = false;
                return Promise.all([
                    this._dateTimePickerComp.shutdown(),
                    this._dateOkButtonComp.shutdown(),
                    this._dateCancelButtonComp.shutdown(),
                ]);
            })
            .then(() => {
                this._popupElem.remove();
                this._popupElem = null;
                this._dateLabelElem = null;
                this._dateTimePickerComp = null;
                this._dateOkButtonComp = null;
                this._dateCancelButtonComp = null;
                this._okCancelElem.remove();
                this._okCancelElem = null;

                this.removeAllListeners();
            })
            .catch((err) => {
                console.error(err);
            });
    }
    _registerListeners() {
        this._dateLabelElem.addEventListener(
            "click",
            (this._onDateLabelClick = this._onDateLabelClick.bind(this))
        );
        this._dateOkButtonComp.on("UserClick", (this._onDateOk = this._onDateOk.bind(this)));
        this._dateCancelButtonComp.on(
            "UserClick",
            (this._onDateCancel = this._onDateCancel.bind(this))
        );
        this._popupElem.addEventListener(
            "click",
            (this._onPopupClick = this._onPopupClick.bind(this))
        );
    }
    _unregisterListeners() {
        this._dateLabelElem.removeEventListener("click", this._onDateLabelClick);
        this._dateOkButtonComp.removeListener("UserClick", this._onDateOk);
        this._dateCancelButtonComp.removeListener("UserClick", this._onDateCancel);
    }
    _onDateLabelClick(event) {
        event.stopImmediatePropagation();
        this._dateTimePickerComp.setValue(moment(this.getValue()));
        this._showElm(this._popupElem);
        document.addEventListener("click", this._onBodyClick);
    }

    _triggerValueChange(value) {
        this.emit("ValueChanged", value);
    }

    _triggerCalendarToggled(state) {
        const calendarHeight = this._popupElem.clientHeight;
        this.emit("CalendarToggled", state, calendarHeight);
    }

    _onDateOk() {
        this._hideElm(this._popupElem);
        document.removeEventListener("click", this._onBodyClick);
        let dateTimestamp = this._dateTimePickerComp.value.valueOf();

        this.setValue(dateTimestamp);
        this._triggerValueChange(dateTimestamp);
    }
    _onDateCancel() {
        this._hideElm(this._popupElem);
        document.removeEventListener("click", this._onBodyClick);
    }
    _onPopupClick(event) {
        event.stopImmediatePropagation();
    }
    _onBodyClick() {
        this._hideElm(this._popupElem);
        document.removeEventListener("click", this._onBodyClick);
    }

    _toggleElm(state, ...elements) {
        elements = [].concat(...elements);

        elements.forEach((element) => {
            element = element instanceof Node ? element : element.renderer.rootElement;
            if (state) {
                element.classList.remove("hidden");
            } else {
                element.classList.add("hidden");
            }
        });
    }
    _hideElm(...elements) {
        this._dateLabelElem.focus();
        this._toggleElm(false, elements);
        this._triggerCalendarToggled(false);
    }
    _showElm(...elements) {
        this._toggleElm(true, elements);
        this._triggerCalendarToggled(true);
    }
}
module.exports = DateTimePickerInput;
